import { StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { fontFamily } from '../../theme'
import { palette } from '../../theme/palette'

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: palette.cream
  },
  headerContainerStyle: {
    borderBottomWidth: 0.3,
    borderBottomColor: 'gray'
  },
  profileNameContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 32
  },
  circle: {
    height: 62,
    width: 64,
    backgroundColor: '#FF3ED4',
    borderRadius: 32,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 18
  },
  circleText: {
    fontSize: 20,
    fontFamily: fontFamily.GTAmericaStandardMedium,
    color: '#121212'
  },
  name: {
    fontSize: 24,
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#121212',
    fontWeight: '400'
  },
  referView: {
    marginTop: 32,
    paddingHorizontal: 20
  },
  refertextStyle: {
    fontSize: 16,
    color: '#121212',
    fontWeight: 'bold',
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  header: {
    marginTop: 32,
    fontSize: 14,
    color: '#1E1E1E',
    fontWeight: '700',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    paddingHorizontal: 20
  },
  rowContainer: {
    flexDirection: 'row'
  },
  statsBox: {
    borderColor: '#DDDAD2',
    padding: 16,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    flex: 1
  },
  statsText1: {
    fontSize: 22,
    color: '#121212',
    fontWeight: '400',
    fontFamily: fontFamily.FeatureDeckRegular,
    textAlign: 'center'
  },
  statsText2: {
    marginTop: 8,
    fontSize: 14,
    color: '#000000',
    fontWeight: '400',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    textAlign: 'center'
  },
  achievementContainer: {
    marginTop: 16,
    height: 114,
    width: '100%',
    borderWidth: 1,
    borderColor: '#DDDAD2',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4
  },
  achievementText: {
    fontSize: 14,
    color: '#000000',
    fontWeight: '400',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    textAlign: 'center'
  },
  accountContainer: {
    flex: 1,
    padding: 16,
    marginTop: 16,
    borderWidth: 1,
    borderColor: '#DDDAD2',
    borderRadius: 4,
    paddingHorizontal: 20
  },
  nameView: {
    flex: 1,
    flexDirection: 'row'
  },
  box1: {
    flex: 3,
    alignItems: 'flex-start',
    height: 50,
    justifyContent: 'space-between'
  },
  box2: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  seperator: {
    marginVertical: 16,
    borderWidth: 1,
    borderColor: '#DDDAD2'
  },
  editText: {
    fontSize: 16,
    color: '#121212',
    fontWeight: '400',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    textDecorationLine: 'underline'
  },
  title: {
    fontSize: 12,
    color: '#121212',
    fontWeight: '700',
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  value: {
    fontSize: 18,
    color: '#000000',
    fontWeight: '400',
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  delete: {
    fontSize: 16,
    color: '#121212',
    fontWeight: '500',
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  // Style for Edit Profile Screen
  question: {
    marginTop: 48,
    fontWeight: '400',
    fontFamily: fontFamily.FeatureDeckRegular,
    color: '#121212',
    fontSize: 28,
    lineHeight: 34
  },
  email: {
    marginTop: 5,
    fontWeight: '400',
    fontFamily: fontFamily.GTAmericaStandardMedium,
    color: '#121212',
    fontSize: 20
  },
  nameText: {
    marginTop: 32,
    fontWeight: 'bold',
    fontFamily: fontFamily.GTAmericaStandardMedium,
    color: '#121212',
    fontSize: 16
  },
  inputField: {
    marginTop: 16,
    height: 50,
    padding: 15,
    borderRadius: 4,
    fontSize: 16,
    paddingStart: 10,
    borderWidth: 1,
    borderColor: '#121212',
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  buttonStyle: {
    height: moderateScale(48),
    width: '100%',
    backgroundColor: '#121212',
    borderRadius: 48,
    position: 'absolute',
    bottom: 25,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  buttonView: {
    paddingHorizontal: 40,
    alignSelf: 'center',
    padding: 2
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardMedium,
    textTransform: 'uppercase'
  },
  loadingStyle: {
    width: 20,
    height: 20,
    right: 0,
    position: 'absolute',
    top: 3
  },
  customLeftCardStyle: {
    transform: [{ rotate: '0deg' }],
    width: 24,
    height: 38,
    borderColor: '#00000055',
    borderWidth: 0.5,
    borderRadius: 3
  },
  customRightCardStyle: {
    transform: [{ rotate: '0deg' }],
    width: 24,
    height: 38,
    borderColor: '#00000055',
    borderWidth: 0.5,
    borderRadius: 3
  },
  playHistoryHeaderContainer: {
    width: '100%',
    flexDirection: 'row',
    paddingVertical: 16,
    borderBottomColor: '#DDDAD2',
    borderBottomWidth: 1
  },
  dateHeader: {
    flex: 1.3,
    alignItems: 'flex-start'
  },
  runTimeHeader: {
    flex: 1.5,
    alignItems: 'flex-start'
  },
  handHeader: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  besthandHeader: {
    flex: 1.5,
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  playHistoryValue: {
    fontSize: 12,
    marginTop: 0
  },
  listValueContainer: {
    width: '100%',
    paddingVertical: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16
  },
  valueContainer: {
    flex: 1.3,
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  runValueContainer: {
    flex: 1.5,
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingLeft: 12
  },
  handValueContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  playHoleCardValueContainer: {
    flex: 1.5,
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  valueTextStyle: {
    color: '#121212',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaExtendedMedium
  },
  runtimeValueTextStyle: {
    color: '#121212',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  footerContainer: {
    borderTopColor: '#DDDAD2',
    borderTopWidth: 1
  },
  footerTitleStyle: {
    color: '#121212',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontWeight: '500'
  },
  playHistoryTableStyle: {
    borderColor: '#DDDAD2',
    borderWidth: 1,
    borderRadius: 4,
    marginTop: 16
  },
  error: {
    marginTop: 16,
    color: '#A10000',
    fontSize: 14,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontWeight: '400'
  },
  bottomSheetHandleStyle: {
    backgroundColor: '#F6F2E9',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 0,
    height: 32
  },
  bottomSheetIndicatorStyle: {
    backgroundColor: 'gray',
    height: 2,
    width: 44
  }

  // screenContainer: {
  //   flex: 1
  // },
  // navBar: {
  //   paddingHorizontal: 15,
  //   flexDirection: 'row',
  //   paddingVertical: 15,
  //   justifyContent: 'space-between',
  //   alignItems: 'center',
  //   marginTop: 50,
  //   marginHorizontal: 12,
  //   borderRadius: 8,
  //   backgroundColor: '#131E46'
  // },
  // backText: {
  //   color: '#000',
  //   fontWeight: '900',
  //   textTransform: 'uppercase'
  // },
  // backButton: {
  //   alignSelf: 'flex-start',
  //   marginLeft: 10,
  //   marginTop: 10
  // },
  // tabBarView: {
  //   marginTop: 38,
  //   marginBottom: 10,
  //   flexDirection: 'row',
  //   justifyContent: 'space-around',
  //   paddingHorizontal: 5
  // },
  // userAvatar: {
  //   width: 110,
  //   height: 110,
  //   borderRadius: 55,
  //   marginTop: 41
  // },
  // userName: {
  //   paddingVertical: 15,
  //   fontSize: moderateScale(14),
  //   color: '#414969',
  //   fontWeight: '600'
  // },
  // label: {
  //   color: '#414969',
  //   fontSize: moderateScale(16),
  //   paddingTop: 20,
  //   paddingBottom: 10,
  //   textAlign: 'center'
  // },
  // overviewLabel: {
  //   color: '#414969',
  //   fontSize: moderateScale(12),
  //   paddingTop: 20,
  //   paddingBottom: 10,
  //   paddingLeft: 20
  // },
  // deleteAccount: {
  //   fontSize: moderateScale(14),
  //   paddingTop: 20,
  //   paddingBottom: 10,
  //   paddingLeft: 20,
  //   fontWeight: '500',
  //   color: '#659AF5'
  // },
  // values: {
  //   fontSize: moderateScale(21),
  //   color: '#414969',
  //   fontWeight: '700',
  //   textAlign: 'center',
  //   paddingVertical: 15,
  //   backgroundColor: '#CED0D550'
  // },
  // overviewValues: {
  //   fontSize: moderateScale(16),
  //   color: '#414969',
  //   fontWeight: '300',
  //   paddingBottom: 20,
  //   paddingLeft: 20
  // },
  // image: {
  //   flex: 1,
  //   resizeMode: 'cover',
  //   justifyContent: 'center'
  // }
})
